import { combineReducers } from "redux";
import userReducer from "./user/user.reducer";
import readingsReducer from "./readings/readings.reducer";
import routesReducer from "./routes/routes.reducer";
import applicationsReducer from "./applications/applications.reducer";
import licensesReducer from "./licenses/licenses.reducer";

const rootReducer = combineReducers({
  user: userReducer,
  reading: readingsReducer,
  routes: routesReducer,
  applications: applicationsReducer,
  licenses: licensesReducer
});

export type RootReducer = ReturnType<typeof rootReducer>;

export default rootReducer;
